import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { API } from "../../config/api";
import "./../Styles/sidebar.css";
import "./../Styles/AddDesigner.css";
import "./../Styles/Addmachine.css";
import "./../Styles/ChangePassword.css";
import "./../Styles/logout.css";
import "./../Styles/profile.css";
import "./../Styles/viewworkspace.css";

const closeSidebarMobile = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove("sidebar-open");
  }
};

export default function Sidebar() {
  const [machineOpen, setMachineOpen] = useState(false);
  const [designerOpen, setDesignerOpen] = useState(false);
  const [workspaceOpen, setWorkspaceOpen] = useState(false);

  // Loading state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize user state from session storage (fallback)
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        setError(null);

        const savedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
        const userId = savedUser.id || sessionStorage.getItem("userId");

        if (!userId) {
          throw new Error("User ID not found");
        }

        // Use SINGLE USER API ✅
        const response = await fetch(`${API.GET_USER}?id=${userId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.success && result.user) {
          const cleanUser = {
            id: result.user.id,
            name: result.user.name,
            email: result.user.email,
            phone: result.user.phone,
            provider_options: result.user.provider_options || [],
            role: result.user.role,
            account_type: result.user.account_type,
            status: result.user.status,
          };

          sessionStorage.setItem("user", JSON.stringify(cleanUser));
          sessionStorage.setItem("userId", result.user.id);
          setUser(cleanUser);
        } else {
          // Fallback to sessionStorage
          setUser(savedUser);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError(err.message);

        // Fallback to sessionStorage
        try {
          const fallbackUser = JSON.parse(sessionStorage.getItem("user")) || {};
          setUser(fallbackUser);
        } catch {
          setUser({});
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);
  // Listen for "userLogin" event to refresh data
  useEffect(() => {
    const refreshUser = async () => {
      try {
        const userId =
          sessionStorage.getItem("userId") || localStorage.getItem("userId");

        if (userId) {
          const response = await fetch(API.LIST_USERS);

          if (response.ok) {
            const result = await response.json();
            if (result.success && result.users) {
              const currentUser = result.users.find(
                (u) => String(u.id) === String(userId),
              );
              if (currentUser) {
                const cleanUser = {
                  id: currentUser.id,
                  name: currentUser.name,
                  email: currentUser.email,
                  phone: currentUser.phone,
                  provider_options: currentUser.provider_options,
                  role: currentUser.role,
                  account_type: currentUser.account_type,
                };
                sessionStorage.setItem("user", JSON.stringify(cleanUser));
                setUser(cleanUser);
              }
            }
          }
        }
      } catch (err) {
        console.error("Error refreshing user data:", err);
      }
    };

    window.addEventListener("userLogin", refreshUser);
    return () => window.removeEventListener("userLogin", refreshUser);
  }, []);
  const getRoles = () => {
    if (!user.provider_options) return [];

    let options = user.provider_options;

    // handle JSON string
    if (typeof options === "string") {
      try {
        options = JSON.parse(options);
      } catch {
        options = options.split(",");
      }
    }

    return Array.isArray(options)
      ? options.map((r) => r.trim().toLowerCase())
      : [];
  };
  // Handle provider_options as string or array
  //  const getRoles = () => {
  //   if (!user.provider_options) return [];

  //   // Handle both array and string formats
  //   let options = user.provider_options;

  //   if (typeof options === 'string') {
  //     options = options.split(',')
  //                      .map(role => role.trim().toLowerCase())
  //                      .filter(role => role.length > 0);
  //   }

  //   return Array.isArray(options) ? options : [];
  // };
  const roles = getRoles();

  // Permissions based on provider_options
  const canMachine = roles.includes("machines");
  const canDesigner = roles.includes("designers");
  const canWorkspace = roles.includes("workspaces");

  // In Sidebar.js, after getRoles()

  console.log("🔍 DEBUG - Raw provider_options:", user.provider_options);
  console.log("🔍 DEBUG - Parsed roles:", roles);
  console.log("🔍 DEBUG - Can Machine:", canMachine);
  console.log("🔍 DEBUG - Can Designer:", canDesigner);
  console.log("🔍 DEBUG - Can Workspace:", canWorkspace);

  // Show loading state while fetching
  if (loading) {
    return (
      <div className="us-container">
        <div className="us-sidebar">
          <h2 className="us-logo">User Panel</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "2rem",
              color: "#666",
              fontSize: "14px",
            }}
          >
            <i
              className="bi bi-hourglass-split"
              style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
            ></i>
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // Show error state but still render sidebar with fallback data
  if (error && Object.keys(user).length === 0) {
    return (
      <div className="us-container">
        <div className="us-sidebar">
          <h2 className="us-logo">User Panel</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "2rem",
              color: "#e74c3c",
              fontSize: "14px",
            }}
          >
            <i
              className="bi bi-exclamation-triangle"
              style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
            ></i>
            <span>Failed to load user data</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="us-container">
      <div
        className="sidebar-overlay"
        onClick={() => document.body.classList.remove("sidebar-open")}
      ></div>

      <div className="us-sidebar">
        <h2 className="us-logo">User Panel</h2>

        <ul className="us-menu">
          {/* Dashboard - Always visible */}
          <li>
            <Link
              to="/user/dashboard"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-speedometer2"></i>
              <span>Dashboard</span>
            </Link>
          </li>

          {/* Machines - Conditional */}
          {canMachine && (
            <li>
              <div
                className="us-menu-title"
                onClick={() => setMachineOpen(!machineOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-gear"></i>
                  <span>Manage Machines</span>
                </div>
                <i
                  className={`bi ${
                    machineOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {machineOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-machine" onClick={closeSidebarMobile}>
                      Add Machine
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* Designers - Conditional */}
          {canDesigner && (
            <li>
              <div
                className="us-menu-title"
                onClick={() => setDesignerOpen(!designerOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-palette"></i>
                  <span>Manage Designers</span>
                </div>
                <i
                  className={`bi ${
                    designerOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {designerOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-designer" onClick={closeSidebarMobile}>
                      Add Designer
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* Workspace - Conditional */}
          {canWorkspace && (
            <li>
              <div
                className="us-menu-title"
                onClick={() => setWorkspaceOpen(!workspaceOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-building"></i>
                  <span>Manage Workspace</span>
                </div>
                <i
                  className={`bi ${
                    workspaceOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {workspaceOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-workspace" onClick={closeSidebarMobile}>
                      Add Workspace
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* Profile - Always visible */}
          <li>
            <Link
              to="/user/profile"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-circle"></i>
              <span>Profile</span>
            </Link>
          </li>

          {/* Logout - Always visible */}
          <li>
            <Link
              to="/user/logout"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
